export default "__VITE_ASSET__C9Wf8oH2__"